module.exports = __webpack_public_path__ + "media/images/icon_nav_category_sp-dc2c7db190549187e3b1160bd6e35288.svg";